import { createFeatureSelector, createSelector } from '@ngrx/store';
import { UrlParamsState } from './url-params.state';

// selectors
export const selectUrlParamsModule = createFeatureSelector<UrlParamsState>('urlParams');
export const selectUrlParams = createSelector(selectUrlParamsModule, (state: UrlParamsState) => state.urlParams);
export const selectLang = createSelector(selectUrlParamsModule, (state: UrlParamsState) => state.urlParams.lang);
export const selectAccessToken = createSelector(selectUrlParamsModule, (state: UrlParamsState) => state.urlParams.access_token);
export const selectAuthentication = createSelector(selectUrlParamsModule, (state: UrlParamsState) => state.authentication);
export const selectAuthenticationLoading = createSelector(selectUrlParamsModule, (state: UrlParamsState) => state.authentication.loading);
export const selectAuthenticationError = createSelector(selectUrlParamsModule, (state: UrlParamsState) => state.authentication.errorDescription);




// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./~/angular-router-loader/src!./~/tslint-loader!./src/app/modules/url-params/url-params.selector.ts